import AutosizingTextarea from "~/components/shared/AutosizingTextarea";
import labelled from "~/components/shared/labelledFormComponent";

const FormTextarea = labelled("textarea");
FormTextarea.Autosize = labelled(AutosizingTextarea);
FormTextarea.Autosize.proxyMethods = ["updateAutoresize"];

export default FormTextarea;
